import {useEffect, useMemo, useState} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {fetchRegionsMonthlyAveragePrices, IRegionMonthlyAveragePrices} from "../../region/api/fetch_regions_monthly_average_prices";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedLocationPrice} from "../types/IPersonalizedHomepage";
import {getLatestPricedMonth, getPersonalizedPriceRegions, mapMonthlyAveragePricesToPersonalized} from "../utils/map_location_prices_to_personalized";

interface IProps {
    isRecentFiltersMounted: boolean;
    areRecentlyViewedPropertiesLoading: boolean;
    recentFilters: IRecentFilter[];
    recentlyViewedPropertyDetails: IPropertyDetail[];
}

interface IPersonalizedLocationPricesResult {
    locationPrices: IPersonalizedLocationPrice[];
    /** Latest `YYYY-MM` month carrying data, for the "Dane: …" footer note. */
    latestPricedMonth: string | null;
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

/**
 * One batched request serves all locations; the backend already assigns
 * prices down the region tree (city → district → estate), so regions without
 * BigData coverage simply drop out of the list instead of getting mock data.
 */
export const usePersonalizedLocationPrices = (props: IProps): IPersonalizedLocationPricesResult => {
    const isSourceDataReady = props.isRecentFiltersMounted && !props.areRecentlyViewedPropertiesLoading;
    const priceRegions = useMemo(
        () => getPersonalizedPriceRegions(props.recentFilters, props.recentlyViewedPropertyDetails),
        [props.recentFilters, props.recentlyViewedPropertyDetails]
    );
    const priceRegionsKey = useMemo(() => priceRegions.map((priceRegion) => priceRegion.id).join(","), [priceRegions]);
    const [locationPrices, setLocationPrices] = useState<IPersonalizedLocationPrice[]>([]);
    const [latestPricedMonth, setLatestPricedMonth] = useState<string | null>(null);
    const [resolvedPriceRegionsKey, setResolvedPriceRegionsKey] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        let isCancelled = false;

        if (!isSourceDataReady) {
            return () => {
                isCancelled = true;
            };
        }

        if (priceRegions.length === 0) {
            setLocationPrices([]);
            setLatestPricedMonth(null);
            setResolvedPriceRegionsKey(priceRegionsKey);
            setIsLoading(false);
            setIsError(false);

            return () => {
                isCancelled = true;
            };
        }

        setIsLoading(true);
        setIsError(false);

        fetchRegionsMonthlyAveragePrices(
            {},
            priceRegions.map((priceRegion) => priceRegion.regionId)
        )
            .then((response) => {
                if (isCancelled) {
                    return;
                }

                // The response order does not follow the request order.
                const monthlyPricesByRegionId = new Map<number, IRegionMonthlyAveragePrices>(
                    (response.results ?? []).map((region) => [region.id, region.stats?.average_price_m2_by_month ?? {}])
                );
                const mappedRegions = priceRegions.map((priceRegion) => {
                    const monthlyAveragePrices = monthlyPricesByRegionId.get(priceRegion.regionId);

                    return {monthlyAveragePrices, price: mapMonthlyAveragePricesToPersonalized({priceRegion, monthlyAveragePrices})};
                });
                const displayedRegions = mappedRegions.filter(
                    (mappedRegion): mappedRegion is typeof mappedRegion & {price: IPersonalizedLocationPrice} => mappedRegion.price !== null
                );

                setLocationPrices(displayedRegions.map((displayedRegion) => displayedRegion.price));
                // The footer freshness label must describe the rows that render,
                // not series of regions that were dropped for lack of data.
                setLatestPricedMonth(getLatestPricedMonth(displayedRegions.map((displayedRegion) => displayedRegion.monthlyAveragePrices)));
                setResolvedPriceRegionsKey(priceRegionsKey);
                setIsLoading(false);
            })
            .catch(() => {
                if (isCancelled) {
                    return;
                }

                setLocationPrices([]);
                setLatestPricedMonth(null);
                setResolvedPriceRegionsKey(priceRegionsKey);
                setIsError(true);
                setIsLoading(false);
            });

        return () => {
            isCancelled = true;
        };
    }, [isSourceDataReady, priceRegions, priceRegionsKey]);

    const hasCurrentPrices = priceRegionsKey === resolvedPriceRegionsKey;

    return {
        locationPrices: hasCurrentPrices ? locationPrices : [],
        latestPricedMonth: hasCurrentPrices ? latestPricedMonth : null,
        isLoading: !isSourceDataReady || isLoading || (priceRegions.length > 0 && !hasCurrentPrices),
        isError,
        isEmpty: isSourceDataReady && priceRegions.length === 0
    };
};
import {useEffect, useMemo, useState} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {fetchRegionsMonthlyAveragePrices, IRegionMonthlyAveragePrices} from "../../region/api/fetch_regions_monthly_average_prices";
import {IRecentFilter} from "../../search/utils/recent_filters_storage";
import {IPersonalizedLocationPrice} from "../types/IPersonalizedHomepage";
import {getLatestPricedMonth, getPersonalizedPriceRegions, mapMonthlyAveragePricesToPersonalized} from "../utils/map_location_prices_to_personalized";

interface IProps {
    isRecentFiltersMounted: boolean;
    areRecentlyViewedPropertiesLoading: boolean;
    recentFilters: IRecentFilter[];
    recentlyViewedPropertyDetails: IPropertyDetail[];
}

interface IPersonalizedLocationPricesResult {
    locationPrices: IPersonalizedLocationPrice[];
    /** Latest `YYYY-MM` month carrying data, for the "Dane: …" footer note. */
    latestPricedMonth: string | null;
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

/**
 * One batched request serves all locations; the backend already assigns
 * prices down the region tree (city → district → estate), so regions without
 * BigData coverage simply drop out of the list instead of getting mock data.
 */
export const usePersonalizedLocationPrices = (props: IProps): IPersonalizedLocationPricesResult => {
    const isSourceDataReady = props.isRecentFiltersMounted && !props.areRecentlyViewedPropertiesLoading;
    const priceRegions = useMemo(
        () => getPersonalizedPriceRegions(props.recentFilters, props.recentlyViewedPropertyDetails),
        [props.recentFilters, props.recentlyViewedPropertyDetails]
    );
    const priceRegionsKey = useMemo(() => priceRegions.map((priceRegion) => priceRegion.id).join(","), [priceRegions]);
    const [locationPrices, setLocationPrices] = useState<IPersonalizedLocationPrice[]>([]);
    const [latestPricedMonth, setLatestPricedMonth] = useState<string | null>(null);
    const [resolvedPriceRegionsKey, setResolvedPriceRegionsKey] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        let isCancelled = false;

        if (!isSourceDataReady) {
            return () => {
                isCancelled = true;
            };
        }

        if (priceRegions.length === 0) {
            setLocationPrices([]);
            setLatestPricedMonth(null);
            setResolvedPriceRegionsKey(priceRegionsKey);
            setIsLoading(false);
            setIsError(false);

            return () => {
                isCancelled = true;
            };
        }

        setIsLoading(true);
        setIsError(false);

        fetchRegionsMonthlyAveragePrices(
            {},
            priceRegions.map((priceRegion) => priceRegion.regionId)
        )
            .then((response) => {
                if (isCancelled) {
                    return;
                }

                // The response order does not follow the request order.
                const monthlyPricesByRegionId = new Map<number, IRegionMonthlyAveragePrices>(
                    (response.results ?? []).map((region) => [region.id, region.stats?.average_price_m2_by_month ?? {}])
                );
                const mappedRegions = priceRegions.map((priceRegion) => {
                    const monthlyAveragePrices = monthlyPricesByRegionId.get(priceRegion.regionId);

                    return {monthlyAveragePrices, price: mapMonthlyAveragePricesToPersonalized({priceRegion, monthlyAveragePrices})};
                });
                const displayedRegions = mappedRegions.filter(
                    (mappedRegion): mappedRegion is typeof mappedRegion & {price: IPersonalizedLocationPrice} => mappedRegion.price !== null
                );

                setLocationPrices(displayedRegions.map((displayedRegion) => displayedRegion.price));
                // The footer freshness label must describe the rows that render,
                // not series of regions that were dropped for lack of data.
                setLatestPricedMonth(getLatestPricedMonth(displayedRegions.map((displayedRegion) => displayedRegion.monthlyAveragePrices)));
                setResolvedPriceRegionsKey(priceRegionsKey);
                setIsLoading(false);
            })
            .catch(() => {
                if (isCancelled) {
                    return;
                }

                setLocationPrices([]);
                setLatestPricedMonth(null);
                setResolvedPriceRegionsKey(priceRegionsKey);
                setIsError(true);
                setIsLoading(false);
            });

        return () => {
            isCancelled = true;
        };
    }, [isSourceDataReady, priceRegions, priceRegionsKey]);

    const hasCurrentPrices = priceRegionsKey === resolvedPriceRegionsKey;

    return {
        locationPrices: hasCurrentPrices ? locationPrices : [],
        latestPricedMonth: hasCurrentPrices ? latestPricedMonth : null,
        isLoading: !isSourceDataReady || isLoading || (priceRegions.length > 0 && !hasCurrentPrices),
        isError,
        isEmpty: isSourceDataReady && priceRegions.length === 0
    };
};
